<!--
Este componente recibe como parametros las varibles de control de visibilidad de
las flechas de avanzar y retroceder (atrasVisible y adelanteVisible). También recibe los diálogoa reproducir.
El componente automáticamente actualiza el texto (currentText) y devuelve el nuevo valor
a través de la función :update:currentText para notificar al padre.
recibe instructor: Number (tres instructores)
NOTA: Se asume que los diálogos siempre van a empezar en el diálogo 0
-->
<template>
    <v-layout align-center justify-center row>
        <v-flex class="animated fadeInDown">
            <v-layout row wrap align-center class="cont-dialogo">
                <v-flex xs2 md2 sm2>
                    <div class="personaje text-xs-center md2 sm2 xs12" >
                        <img :src="require('@/assets/imagenes_compartidas/personaje-'+personaje+'.png')">
                    </div>
                </v-flex>
                <v-flex class="dialogos" :class="{'dialogos-center':diagCenter}" xs12 md11 sm12 >
                    <div @click="adelante" class="flecha-adelante diagnav hvr animated pulse animainfinite"
                            v-show="adelanteVisible && currentText < dialogos.length - 1">
                            <v-icon class="icon" >keyboard_arrow_right</v-icon>
                    </div>
                    <div @click="atras" class="flecha-atras diagnav hvr animated bounceIn"
                            v-show="atrasVisible && currentText>0">
                        <v-icon class="icon" >keyboard_arrow_left</v-icon>
                    </div>
                    <v-layout align-center justify-center class="ml-2" row>
                        <v-flex>
                            <p :id="'diag-'+idx" :key="idx" v-for="(dialogo, idx) in dialogos"
                                v-show="currentText == idx"><span v-html="dialogo"></span></p>
                            <slot></slot>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap row align-center justify-center class="ml-2">
                        <v-flex class="">
                            <slot name="contentDialog"></slot>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>
<script>
export default {
    props: {
        atrasVisible: {
            type: Boolean,
            default: true
        },
        adelanteVisible: {
            type: Boolean,
            default: true
        },
        dialogos: {
            type: Array,
            required: true
        },
        personaje: {
            type: String,
            default: "0"
        },
        diagCenter:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            imgPersonaje: '',
            currentText: 0,
            arrPersonaje: [""],
            background: ''
        }
    },
    created() {
        try {
            for (var i = 0; i < 3; i++) {
                this.getPng('', data => {
                    this.arrPersonaje.push(data);
                });
            }
            this.cambiarPersonaje(this.personaje);
        } catch (error) {
            console.log('Se registra error con funcion: getPng()')
        }
    },
    methods: {
        atras() {
            this.currentText--;
            this.$emit('update:currentText', this.currentText);
        },
        adelante() {
            this.currentText++;
            this.$emit('update:currentText', this.currentText);
        },
        saltarAlDialogo(numeroDialogo) {
            this.currentText = numeroDialogo;
            this.$emit('update:currentText', this.currentText);
        },
        cambiarPersonaje(numPersonaje) {
            this.imgPersonaje = this.arrPersonaje[numPersonaje];
        }
    },
    watch: {
        personaje: function (newVal, oldVal) { // watch it
            this.cambiarPersonaje(newVal);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../sass/globals';
// .cont-dialogo{
//     border:solid red;
// }
.personaje {    
    margin: 0 auto;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-right: -30px;
    margin-top: -30px;
    height: 40px;
    img {
        width: 40px;
            margin-top: 48px;
    }
    @media screen and (max-width: 900px) {
        width: 50px;
        height: 50px;
        margin:0 auto;
        margin-top: -30px;
        img{
            width: 50px;
            margin-top: 48px;
        }       
    }
    @media screen and (min-width: 900px) {
        margin-right: -30px;
    }
    @media screen and (min-width: 960px) {
        margin-right: -30px;
    }
}

.dialogos {
    position: relative;
    padding: 15px;
    // padding-left: 55px;
    // padding-right: 30px;
    margin: 0 auto;
    border-radius: 10px;
    text-align: left;
    p {
        margin: 0;
        font-size: 1.1em;
        color: $color-inverted;
    }
    padding-top: 30px;
    margin-bottom: 8px;
    background-color: $color-secondary;
}
.diagnav {
    width:30px;
    height: 100%;
    cursor: pointer;
    right: 2px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon{
        font-size: 40px;
    }
    &:hover{
        .icon{
            color:$color-secondary;
        }
    }
}
.flecha-atras {
    left: 35px;
    top: 0;
}
.flecha-adelante {
    right: 0;
    top: 0;
}
p {
    font-family:FontBase-Italic;
    line-height: 1.3em;
}
.dialogos-center{
    text-align: center;
}
.animainfinite{
    animation-iteration-count: infinite;
    animation-duration: 0.7s;
}
.icon{
    color: $color-text;
}
</style>